var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "content__frame d-flex align-items-center h-100 pl-24 pt-32 pb-32 margin-top-16 font-16 important-text-note"
    },
    [
      _c("div", [
        _c("span", { staticClass: "txt-bold" }, [
          _vm._v("For Singapore PayNow Only: ")
        ]),
        _c("span", [
          _vm._v(
            " You can also pay using Online Banking with PayNow method. Please "
          ),
          _c(
            "a",
            {
              attrs: { "data-testid": "click-here" },
              on: { click: _vm.handleClickhereBankingOnlinePayNow }
            },
            [
              _c("span", { staticClass: "click-here-highlight" }, [
                _vm._v("click here")
              ])
            ]
          ),
          _vm._v(" to continue. ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }